import { CmsApiPage } from 'modules/cms/api/types/CmsApiPage';

// Types

export type MainStoreContentsState = {
  byUrl: Record<
    string,
    { type: string; content: CmsApiPage } & {
      state: 'SUCCESS' | 'NOT_FOUND' | 'FETCHING';
    }
  >;
};

export type FetchPageRequestAction = {
  type: 'FETCH_PAGE_REQUEST';
  url: string;
};

export type FetchPageSuccessAction = {
  type: 'FETCH_PAGE_SUCCESS';
  content: {
    content: CmsApiPage;
    type: string;
  };
  url: string;
};

export type FetchPageFailureAction = {
  type: 'FETCH_PAGE_FAILURE';
  url: string;
};

export type ClearPagesAction = {
  type: 'CLEAR_PAGES';
};

export type MainStoreContentsAction =
  | FetchPageRequestAction
  | FetchPageSuccessAction
  | FetchPageFailureAction
  | ClearPagesAction;

// Reducer

const defaultState = {
  byUrl: {},
};

export function contentsReducer(
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/default-param-last
  state: MainStoreContentsState = defaultState,
  action: MainStoreContentsAction,
) {
  switch (action.type) {
    case 'CLEAR_PAGES':
      return {
        ...state,
        byUrl: {},
      };

    case 'FETCH_PAGE_REQUEST':
      return {
        ...state,
        byUrl: {
          ...state.byUrl,
          [action.url]: { ...state.byUrl[action.url], state: 'FETCHING' },
        },
      };

    case 'FETCH_PAGE_SUCCESS': {
      return {
        ...state,
        byUrl: {
          ...state.byUrl,
          [action.url]: {
            ...state.byUrl[action.url],
            ...action.content,
            state: 'SUCCESS',
          },
        },
      };
    }

    case 'FETCH_PAGE_FAILURE': {
      return {
        ...state,
        byUrl: {
          ...state.byUrl,
          [action.url]: { ...state.byUrl[action.url], state: 'NOT_FOUND' },
        },
      };
    }

    default:
      return state;
  }
}
